import * as Constants from './constants'

export const lichSuTraThuongListRequest = (formData) => {
  return {
    type: Constants.LS_TRATHUONG_LIST_REQUESTING,
    payload: formData
  }
}

export const lichSuTraThuongListSuccess = (data) => {
  return {
    type: Constants.LS_TRATHUONG_LIST_SUCCESS,
    data
  }
}

export const lichSuTraThuongListError = (error) => {
  return {
    type: Constants.LS_TRATHUONG_LIST_ERROR,
    error
  }
}

export const lichSuTraThuongExportXlsRequest = (formData, callback) => {
  return {
    type: Constants.LS_TRATHUONG_EXPORT_XLS_REQUESTING,
    payload: formData,
    callback
  }
}

export const lichSuTraThuongExportXlsSuccess = (data) => {
  return {
    type: Constants.LS_TRATHUONG_EXPORT_XLS_SUCCESS,
    data
  }
}

export const lichSuTraThuongExportXlsError = (error) => {
  return {
    type: Constants.LS_TRATHUONG_EXPORT_XLS_ERROR,
    error
  }
}


export const lichSuTraThuongRemoveRequest = (formData, callback) => {
  return {
    type: Constants.LS_TRATHUONG_REMOVE_REQUESTING,
    payload: formData,
    callback
  }
}

export const lichSuTraThuongRemoveSuccess = (response) => {
  return {
    type: Constants.LS_TRATHUONG_REMOVE_SUCCESS,
    payload: response
  }
}

export const lichSuTraThuongRemoveError = (error) => {
  return {
    type: Constants.LS_TRATHUONG_REMOVE_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/LichSuTraThuong/actions.js